<template>
  <div class="card">
    <div class="card-header">
      <h4>{{ $t('priority.self') }}</h4>
    </div>
    <div class="card-body">
      <a-button
        class="mb-3"
        type="link"
        icon="plus"
        @click="showFormModal()"
      >
        {{ $t('common.add') }}
      </a-button>
      <a-table
        row-key="hash_id"
        :loading="loading"
        :data-source="products"
        :columns="columns"
        :pagination="false"
        bordered
        responsive
      >
        <template
          slot="product"
          slot-scope="text"
        >
          {{ $l(text) }}
        </template>
        <template
          slot="actions"
          slot-scope="id, row"
        >
          <div class="d-flex justify-content-around">
            <a-button
              class="mr-2 mb-2"
              icon="edit"
              variant="light"
              @click="showFormModal(row)"
            />
            <a-popconfirm
              :title="$t('common.are_you_sure')"
              :ok-text="$t('common.delete')"
              :cancel-text="$t('common.cancel')"
              @confirm="handleDelete(row)"
            >
              <a-icon
                slot="icon"
                type="question-circle-o"
                style="color: red"
              />
              <a-button
                icon="delete"
              />
            </a-popconfirm>
          </div>
        </template>
      </a-table>
      <a-modal
        :title="form.id ? $t('priority.edit') : $t('priority.add_new')"
        :visible="formModalVisible"
        :footer="null"
        :width="800"
        @cancel="formModalVisible = false"
      >
        <PriorityProductForm
          :company-list="companyList"
          :product-list="companyProducts"
          :loading="loading"
          :form="form"
          @companySelect="handleCompanySelect"
          @onSearch="handleSearch"
          @submit="handleSave"
        />
      </a-modal>
    </div>
  </div>
</template>

<script>
import PriorityProductsService from '@/services/api/admin/library/priority-products-service'

import PriorityProductForm from '@/components/admin/products/PriorityProductForm'
export default {
  name: 'PriorityProducts',
  components: {
    PriorityProductForm,
  },
  data () {
    return {
      loading: false,
      products: [],
      formModalVisible: false,
      companyProducts: [],
      companyList: [],
      company: null,
      form: {
        id: null,
        priority: null,
        product: null,
      },
      columns: [
        {
          title: this.$t('priority.company'),
          dataIndex: 'company_name',
        },
        {
          title: this.$t('priority.product'),
          dataIndex: 'product_name',
          scopedSlots: { customRender: 'product' },
        },
        {
          title: this.$t('priority.value'),
          dataIndex: 'priority',
          width: '110px',
        },
        {
          dataIndex: 'hash_id',
          width: '150px',
          scopedSlots: {
            customRender: 'actions',
          },
        },
      ],
    }
  },

  async mounted() {
    await this.getProducts()
    await this.getCompanies()
  },

  methods: {
    async getProducts() {
      this.loading = true
      try {
        const { data: { content } } = await PriorityProductsService.getProducts()
        this.products = content
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async getCompanies() {
      this.loading = true
      try {
        const { data: { content } } = await PriorityProductsService.getCompanies()
        this.companyList = content
          .map(company => {
            return {
              id: company.general_info.id,
              name: company.general_info.title,
            }
          })
          .sort((a, b) => {
            if (this.$l(a.name) < this.$l(b.name)) { return -1 }
            if (this.$l(a.name) > this.$l(b.name)) { return 1 }
            return 0
          })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    showFormModal(row) {
      this.formModalVisible = true
      if (row) {
        this.form = {
          id: row.hash_id,
          priority: row.priority,
          product: row.product_hash,
          company: row.seller_company_hash,
        }
      } else {
        this.form = {
          id: null,
          priority: null,
          product: null,
          company: null,
        }
      }
    },

    async handleSave(form) {
      this.loading = true
      const payload = {
        priority: form.priority,
        product_hash: form.product,
      }
      try {
        if (form.id) {
          payload.recommended = true
          await PriorityProductsService.updateProduct(form.id, payload)
        } else {
          await PriorityProductsService.createProduct(payload)
        }
        await this.getProducts()
        this.formModalVisible = false
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    handleCompanySelect(company) {
      this.company = company
    },

    async handleSearch(value) {
      if (value.length < 3) {
        this.companyProducts = []
        return
      }
      this.loading = true
      try {
        const { data: { content } } = await PriorityProductsService.getCompanyProducts(this.company, value)
        this.companyProducts = content.map(product => {
          return {
            id: product.id,
            name: product.variation.title,
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async handleDelete(row) {
      const payload = {
        product_hash: row.product_hash,
        priority: row.priority,
        recommended: false,
      }
      this.loading = true
      try {
        await PriorityProductsService.updateProduct(row.hash_id, payload)
        this.getProducts()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
